(function() {
    function funcReady() {
        $('.KRC0016').buildCommonUI();

        var componentAnimateObj = $('.KRC0016');

        componentAnimateObj.each(function(){
            var visualObj = $(this).find('.visual-area');
            var visualTarget = visualObj.find('.show-cut');
            var playTimer = 1000;
            var easing = 'easeOutCubic';
            $(window).resize(function(){
                $(window).scroll(function(){
                    var windowTop = $(window).scrollTop();
                    var windowHeight = $(window).height();
                    var brw_btm = (windowTop + windowHeight);
                    var positionFix = visualObj.height()/2;
                    var objPosition = visualObj.offset().top + positionFix;
                    if ( windowTop < objPosition && objPosition < brw_btm ) {
                        if (visualObj.hasClass('show-cut-bt') && !visualObj.hasClass('center')) {
                            visualTarget.addClass('center');
                        } else if ( visualObj.hasClass('show-cut-rl') && !visualObj.hasClass('center')) {
                            visualTarget.addClass('center');
                        } else {
                            return false;
                        }
                    }
                });
            }).resize();
        });
    }

    // BTOCSITE-26022, PDP 컴포넌트 초기화 함수 추가, type: PROD or CONTENTS
    function SAVE_COMPONENT_PDP_DOM_MNG() {
        if (typeof __PDP_DOM_MNG__ === 'undefined') return;
        __PDP_DOM_MNG__.add({
            type: 'CONTENTS', name: 'KRC0016', isFirstLoad: false, fn: function () {
                if(!document.querySelector('.KRC0014')) return false;
                funcReady();
            }
        });
    }

    SAVE_COMPONENT_PDP_DOM_MNG();

    $(document).ready(function() {
        SAVE_COMPONENT_PDP_DOM_MNG();

        if(!document.querySelector('.KRC0016')) return false;
        funcReady();
    });
})();

